import { render, staticRenderFns } from "./AppSocialMediaIcon.vue?vue&type=template&id=77cf671d&scoped=true"
import script from "./AppSocialMediaIcon.vue?vue&type=script&lang=js"
export * from "./AppSocialMediaIcon.vue?vue&type=script&lang=js"
import style0 from "./AppSocialMediaIcon.vue?vue&type=style&index=0&id=77cf671d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cf671d",
  null
  
)

export default component.exports